





































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import DropdownOption from './DropdownOption.vue'

@Component
export default class Dropdown extends Vue {
  public options: DropdownOption[] = []
  public dropdownOpen = false

  @Prop({required: false, default: null})
  public value!: any

  @Prop({required: false, default: 'click', type: String})
  public trigger!: 'click' | 'hover'

  @Prop({required: false, default: 'left', type: String})
  public alignment!: 'left' | 'right'

  @Prop({required: false, default: 'bottom', type: String})
  public position!: 'left' | 'right' | 'bottom' | 'top'

  @Prop({type: String, default: 'Please select'})
  public placeholder!: any

  @Prop({required: false, type: Boolean, default: false})
  public multiselect!: boolean

  protected timeout: NodeJS.Timeout | null = null
  protected dropdownOffset: ClientRect | DOMRect | null = null

  get display () {
    for (const option of this.options) {
      if (option.isSelected) {
        return option.$el.textContent
      }
    }

    return this.placeholder
  }

  created () {
    this.options = this.$children as DropdownOption[]
  }

  mounted ( ) {
    this.$on('select', this.select)
    this.markSelected()
    document.body.addEventListener('click', (e) => {
      if (e.target !== this.$el && !this.$el.contains(e.target as Node)) {
        this.$nextTick(() => {
          this.close()
        })
      }
    })
  }

  moveToBody () {
    const stuff = (this.$refs.dropdownMenu as HTMLElement).offsetTop
    document.body.append(this.$refs.dropdownMenu as Node)
  }

  @Watch('value')
  watchValue () {
    this.markSelected()
  }

  markSelected () {
    this.options.forEach((option) => {
      option.isSelected = this.value === option.value
    })
  }

  select (val: any) {
    this.$emit('input', val)
    this.close()
  }

  clicked () {
    if (this.trigger === 'click') {
      this.toggle()
    }
  }

  mouseenter () {
    if (this.trigger === 'hover') {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.open()
    }
  }

  mouseleave () {
    if (this.trigger === 'hover') {
      this.timeout = setTimeout(this.close, 100)
    }
  }

  open () {
    if (!this.dropdownOpen) {
      this.dropdownOpen = true
      this.$nextTick(() => {
        this.putInPosition()
      })
    }
  }

  putInPosition () {
    const scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body).scrollLeft;
    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body).scrollTop;
    const parent = (this.$el as HTMLElement)
    const offset = parent.getBoundingClientRect()
    const el = this.$refs.dropdownMenu as HTMLElement
    if (!this.dropdownOffset) {
      this.dropdownOffset = el.getBoundingClientRect()
    }

    let top = offset.top + offset.height + scrollTop
    let left = offset.left + scrollLeft

    if (this.alignment === 'right') {
      left -= this.dropdownOffset.width
      left += offset.width
    }

    switch (this.position) {
      case "top":
        top -= this.dropdownOffset.height
        top -= offset.height
        break;
      case "right":
        left += this.dropdownOffset.height
        left += offset.width
        break;
    }

    el.style.top = `${top}px`
    el.style.left = `${left}px`
    el.style.width = `${this.dropdownOffset.width}px`

    document.body.appendChild(el)
  }

  close () {
    if (this.dropdownOpen) {
      document.removeEventListener('click', this.close.bind(this))
      this.dropdownOpen = false
    }
  }

  toggle () {
    if (!this.dropdownOpen) {
      this.open()
    } else {
      this.close()
    }
  }
}
